import React from 'react';
import { Cell, CellHeader, Row, Table } from 'src/presentation/components/DataTables/DataTableStyle';
import { BatteryDataSet } from 'src/integration/types/BatteryDataSet';
import Status, { StatusType } from 'src/presentation/components/ui/Status';
import styled, { css } from 'styled-components';
import Indicator from 'src/presentation/components/ui/Indicator';

interface ComponentProps {
  data: BatteryDataSet[];
}

const StatusCell = styled(Cell)`
  ${() => css`
      display: flex;
      justify-content: center;
      align-items: center;
  `}
`;

const SoCCell = styled(Cell)`
  ${() => css`
      display: flex;
      gap: 4px;
      justify-content: center;
  `}
`;

const BatteryDataTable = ({ data }: ComponentProps) => {
  return (
    <Table>
      <thead>
        <Row>
          <CellHeader $left>Alias</CellHeader>
          <CellHeader>ID</CellHeader>
          <CellHeader>Asset state</CellHeader>
          <CellHeader>Power</CellHeader>
          <CellHeader>Capacity</CellHeader>
          <CellHeader>SoC</CellHeader>
          <CellHeader>SoH</CellHeader>
        </Row>
      </thead>
      <tbody>
        {data.map((row: BatteryDataSet) => (
          <Row key={`table-${row.id}`}>
            <Cell $left $bold>{row.name}</Cell>
            <Cell>{row.id}</Cell>
            <StatusCell><Status type={row.assetState as StatusType}>{row.assetState}</Status></StatusCell>
            <Cell>{row.power.amount}{row.power.unit}</Cell>
            <Cell>{row.capacity.amount}{row.capacity.unit}</Cell>
            <SoCCell><Indicator filledAmount={row.soC.amount} />{row.soC.amount}{row.soH.unit}</SoCCell>
            <Cell>{row.soH.amount}{row.soH.unit}</Cell>
          </Row>
        ))}
      </tbody>
    </Table>
  )
}

export default BatteryDataTable;